"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Ellipsis_1 = __importDefault(require("../Ellipsis/Ellipsis"));
var LeftBoundary = /** @class */ (function (_super) {
    __extends(LeftBoundary, _super);
    function LeftBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genClasses = function (isDisable) {
            var isActive = _this.props.isActive;
            var classes = "first-btn page-btn " + isActive(1);
            classes += isDisable ? ' disable' : '';
            return classes;
        };
        _this.genSecondPageOrEllipsis = function () {
            var _a = _this.props, ellipsisToggle = _a.ellipsisToggle, onPageChangeHandle = _a.onPageChangeHandle, onEllipsisClick = _a.onEllipsisClick, expandEllipsis = _a.expandEllipsis, i18nGoTo = _a.i18nGoTo;
            return (React.createElement(Ellipsis_1.default, { expandEllipsis: expandEllipsis, ellipsisToggle: ellipsisToggle, options: _this.genOptions(), onClick: function () { return onEllipsisClick(); }, onPageChangeHandle: onPageChangeHandle, i18nGoTo: i18nGoTo }));
        };
        _this.genOptions = function () {
            var _a = _this.props, alphabetical = _a.alphabetical, lastOption = _a.lastOption, disabledPages = _a.disabledPages;
            var options = [];
            var _loop_1 = function (page) {
                var option = { value: page, text: '' };
                if (alphabetical) {
                    option.text = String.fromCharCode(96 + page).toUpperCase();
                }
                else {
                    option.text = page.toString();
                }
                if (disabledPages) {
                    disabledPages.forEach(function (disabledPage) {
                        if (disabledPage === page) {
                            option.disabled = true;
                        }
                    });
                }
                options.push(option);
            };
            for (var page = 2; page < lastOption; page++) {
                _loop_1(page);
            }
            return options;
        };
        return _this;
    }
    LeftBoundary.prototype.render = function () {
        var _a = this.props, alphabetical = _a.alphabetical, onPageChangeHandle = _a.onPageChangeHandle, isPageDisabled = _a.isPageDisabled;
        var value = alphabetical ? 'A' : 1;
        var isDisable = isPageDisabled(value);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "" + this.genClasses(isDisable), onClick: function () {
                    if (!isDisable) {
                        onPageChangeHandle(1);
                    }
                } }, value),
            this.genSecondPageOrEllipsis()));
    };
    return LeftBoundary;
}(React.Component));
exports.default = LeftBoundary;
